const state = {
  all: [],
  simple: [],
  allBuildings: [],
  allHouses: []
}

const getters = {
  getBuildingById: (state) => (id) => {
    return state.all.find(building => building.id === id)
  }
}

const actions = {
  getAllBuildings({ commit }) {
    axios
      .get("/admin/getAllBuildings")
      .then(response => (commit('setAllBuldings', response.data)));
  },
  getAllHouses({ commit }) {
    axios
      .get("/electrical/profile/getAllHouses")
      .then(response => (commit('setAllHouses', response.data)));
  },
  getBuildings ({ commit }) {
    axios
      .get("/admin/buildings")
      .then(response => (commit('setData', response.data)));
  },
  addBuilding ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/buildings", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  editBuilding ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/buildings/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getBuilding ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get("/admin/buildings/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getSimpleBuildings ({ commit }) {
    axios
      .get("/buildings")
      .then(response => (commit('setSimple', response.data)));
  },
}

const mutations = {
  setData (state, data) {
    state.all = data.data;
  },
  setAllBuldings (state, data) {
    state.allBuildings = data.data;
  },
  setAllHouses (state, data) {
    state.allHouses = data.data;
  },
  setSimple (state, data) {
    state.simple = data.data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
